import { Channel } from '@hooks/admissions/type';

export const GET_INVITATION = 'get-invitation';
export const GET_EVENT_INVITATIONS = 'get-event-invitations';
export const CREATE_INVITATION = 'create-invitation';
export const EDIT_INVITATION = 'edit-invitation';
export const DELETE_INVITATION = 'delete-invitation';

interface LocaleStrings {
  [key: string]: string | null;
  ca: string | null;
  de: string | null;
  en: string | null;
  es: string | null;
  fr: string | null;
  it: string | null;
  pt: string | null;
}

interface Settings {
  isNominative: boolean;
  isForAllChannels: boolean;
  channelDefaultMaxQuantity: number | null;
}

interface FormField {
  name: string;
  dataType: string;
  isRequired: boolean;
}

interface CheckinTime {
  validFrom: EpochTimeStamp | null;
  validUntil: EpochTimeStamp | null;
}

interface SalesTime {
  openingTime: EpochTimeStamp;
  closingTime: EpochTimeStamp;
}

export interface CreateInvitationRequest {
  settings: Settings;
  name: LocaleStrings;
  description: LocaleStrings;
  bookingFormFields: FormField[];
  eventId: string;
  checkInTime: CheckinTime;
  salesTime: SalesTime;
  ticketHolderFormFields: FormField[];
  channels: Channel[];
  salesQuota: string;
}
